export const FormType = {
  SERVICE: 'SERVICE',
  PROJECT: 'PROJECT',
  SIMPLETASK: 'SIMPLETASK',
  ITEM: 'ITEM',
  SOURCELIST: 'SOURCELIST',
  PRODUCTION: 'PRODUCTION',
};

export const FormTypeAttachment = {
  [FormType.ITEM]: 'itemAttachment',
};
